import { showToast } from '@lokalise/louis';

export const showUnexpectedErrorToast = (options?: { avoidMultiple?: boolean }) => {
    const title = 'Something went wrong, please contact support via chat or hello@lokalise.com';

    showToast({ type: 'error', title, toastId: options?.avoidMultiple ? 'UnexpectedErrorToast' : undefined });

    return title;
};

export default {
    showUnexpectedErrorToast,
};
